import React from "react";

export function CardComp({ src, alt, className }) {
    const shouldWrapInDiv = !className || !className.includes("no-wrapper");

    return shouldWrapInDiv ? (
        <div className="cardImgdiv">
            <img
                src={src}
                alt={alt}
                className={className || "homeImgCard"}
                width="100%"
                height="auto"
                loading="lazy"
            />
        </div>
    ) : (
        <img
            src={src}
            alt={alt}
            className={className || "homeImgCard"}
            width="100%"
            height="auto"
            loading="lazy"
        />
    );
}